function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".no_svg__cls-3{fill:#f0272a}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.8 12a10.1 10.1 0 000-4H10V0a9.92 9.92 0 00-4 .84V8H.2a10.1 10.1 0 000 4H6v7.16a9.92 9.92 0 004 .84v-8z",
  fill: "#f0f0f0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9 9V.05a10.14 10.14 0 00-2 .41V9H.05v1c0 .34 0 .67.05 1H7v8.54A10.14 10.14 0 009 20v-9h11c0-.33.05-.66.05-1s0-.67-.05-1z",
  fill: "#002368"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "no_svg__cls-3",
  d: "M10 8h9.8A10 10 0 0010 0zM6 8V.84A10 10 0 00.2 8zM10 12v8a10 10 0 009.8-8zM6 12H.2A10 10 0 006 19.16z"
});

function SvgNo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "no_svg__Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FwYV8xIiBkYXRhLW5hbWU9IkNhcGEgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjAgMjAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZjBmMGYwO30uY2xzLTJ7ZmlsbDojMDAyMzY4O30uY2xzLTN7ZmlsbDojZjAyNzJhO308L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xOS44LDEyYTEwLjEsMTAuMSwwLDAsMCwwLTRIMTBWMEE5LjkyLDkuOTIsMCwwLDAsNiwuODRWOEguMmExMC4xLDEwLjEsMCwwLDAsMCw0SDZ2Ny4xNkE5LjkyLDkuOTIsMCwwLDAsMTAsMjBWMTJaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNOSw5Vi4wNUExMC4xNCwxMC4xNCwwLDAsMCw3LC40NlY5SC4wNWMwLC4zMywwLC42NiwwLDFzMCwuNjcuMDUsMUg3djguNTRBMTAuMTQsMTAuMTQsMCwwLDAsOSwyMFYxMUgyMGMwLS4zMy4wNS0uNjYuMDUtMXMwLS42Ny0uMDUtMVoiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0xMCw4aDkuOEExMCwxMCwwLDAsMCwxMCwwWiIvPjxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTYsOFYuODRBMTAsMTAsMCwwLDAsLjIsOFoiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0xMCwxMnY4YTEwLDEwLDAsMCwwLDkuOC04WiIvPjxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTYsMTJILjJBMTAsMTAsMCwwLDAsNiwxOS4xNloiLz48L3N2Zz4=";
export { SvgNo as ReactComponent };